/**
 * PDF Export Module - Centralized exports for all PDF generation functionality
 * 
 * Provides clean imports for all PDF export functions while maintaining
 * backward compatibility with existing code
 */

// Core utilities
export * from './pdfCore';

// Audit exports
export {
  exportAuditLogPDF,
  exportCurrentAuditLog,
  getSupportedExportFormats
} from './auditExport';

// Drill exports
export {
  exportDrillsReportPDF,
  exportIndividualDrillPDF
} from './drillExport';

// Defect exports
export {
  exportDefectsReportPDF,
  exportIndividualDefectPDF
} from './defectExport';

// Equipment exports
export {
  exportEquipmentReportPDF,
  exportIndividualEquipmentCheckPDF
} from './equipmentExport';

// Incident exports
export {
  exportIncidentReportPDF,
  exportIncidentBatchPDF
} from './incidentExport';

// Risk Assessment exports
export {
  exportIndividualRiskAssessmentPDF,
  exportRiskAssessmentRegisterPDF,
  exportHighRiskReportPDF
} from './riskAssessmentExport';

// Fleet exports
export {
  exportFleetStatusPDF,
  exportCertificateExpiryPDF,
  exportShoreEditAuditPDF,
  exportEscalationReportPDF
} from './fleetExport';

// Voyage exports (FT-195)
export {
  exportVoyagePDF,
  exportVoyageBatchPDF,
  DATE_RANGE_PRESETS,
  getDateRangeFromPreset
} from './voyageExport';

// Default export for backward compatibility
export default {
  // Audit functions
  exportAuditLogPDF: require('./auditExport').exportAuditLogPDF,
  exportCurrentAuditLog: require('./auditExport').exportCurrentAuditLog,
  getSupportedExportFormats: require('./auditExport').getSupportedExportFormats,
  
  // Drill functions
  exportDrillsReportPDF: require('./drillExport').exportDrillsReportPDF,
  exportIndividualDrillPDF: require('./drillExport').exportIndividualDrillPDF,
  
  // Defect functions
  exportDefectsReportPDF: require('./defectExport').exportDefectsReportPDF,
  exportIndividualDefectPDF: require('./defectExport').exportIndividualDefectPDF,
  
  // Equipment functions
  exportEquipmentReportPDF: require('./equipmentExport').exportEquipmentReportPDF,
  exportIndividualEquipmentCheckPDF: require('./equipmentExport').exportIndividualEquipmentCheckPDF,
  
  // Incident functions
  exportIncidentReportPDF: require('./incidentExport').exportIncidentReportPDF,
  exportIncidentBatchPDF: require('./incidentExport').exportIncidentBatchPDF,

  // Risk Assessment functions
  exportIndividualRiskAssessmentPDF: require('./riskAssessmentExport').exportIndividualRiskAssessmentPDF,
  exportRiskAssessmentRegisterPDF: require('./riskAssessmentExport').exportRiskAssessmentRegisterPDF,
  exportHighRiskReportPDF: require('./riskAssessmentExport').exportHighRiskReportPDF,

  // Fleet functions
  exportFleetStatusPDF: require('./fleetExport').exportFleetStatusPDF,
  exportCertificateExpiryPDF: require('./fleetExport').exportCertificateExpiryPDF,
  exportShoreEditAuditPDF: require('./fleetExport').exportShoreEditAuditPDF,
  exportEscalationReportPDF: require('./fleetExport').exportEscalationReportPDF,

  // Voyage functions (FT-195)
  exportVoyagePDF: require('./voyageExport').exportVoyagePDF,
  exportVoyageBatchPDF: require('./voyageExport').exportVoyageBatchPDF,
  DATE_RANGE_PRESETS: require('./voyageExport').DATE_RANGE_PRESETS,
  getDateRangeFromPreset: require('./voyageExport').getDateRangeFromPreset
};